import { render } from "./VaIconColor.vue?vue&type=template&id=cd14020c"
import script from "./VaIconColor.vue?vue&type=script&lang=js"
export * from "./VaIconColor.vue?vue&type=script&lang=js"

import "./VaIconColor.vue?vue&type=style&index=0&id=cd14020c&lang=scss"
script.render = render

export default script